import { workspaceDetailsSagas } from './detail/saga';
import { rolesSagas } from './role/saga';
import { usersSagas } from './user/saga';

export const workspaceSagas = [...workspaceDetailsSagas, ...rolesSagas, ...usersSagas];
